import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'clsx';
import { Link } from 'react-router-dom';
import { pathsToGuideIds } from '../../../data/rootCategories.json';
import { LocationAndLocalizationContext } from '../../providers/LocationAndLocalizationProvider';
import css from './leftSide.module.scss';

class NavigationMenuItem extends Component {
  static propTypes = {
    item: PropTypes.object.isRequired,
    isSelected: PropTypes.bool,
    subscriptionEnabled: PropTypes.bool.isRequired,
  };

  static contextType = LocationAndLocalizationContext;

  render() {
    const { item, isSelected, subscriptionEnabled } = this.props;
    const { getLocalizedText } = this.context;

    const showItem =
      item.guideId !== pathsToGuideIds.premium || subscriptionEnabled;
    return (
      <div>
        {showItem && (
          <Link
            key={`${item.dataTestId}ListItem`}
            data-testid={`${item.dataTestId}MenuItem`}
            data-nextguideitem={item.guideId}
            to={item.path}
            className={classNames(css.navigationMenuItem, {
              [css.activeMenuItem]: isSelected,
            })}
            onClick={this.handleClick}
          >
            {getLocalizedText(item.textKey)}
          </Link>
        )}
      </div>
    );
  }
}

export default NavigationMenuItem;
